import Image from "next/image";
import React, { FC, Fragment } from "react";
import Link from "next/link";
import { Typography } from "../typography";

interface Props {
  routes: { name: string; href: string }[];
}

const BreadCrumb: FC<Props> = ({ routes }) => (
  <div className="bg-gray-bg1 container w-full ">
    <div className="flex justify-start items-end py-5 md:px-4">
      <Link href="/">
        <div className="w-6 h-6 flex-shrink-0 mx-1">
          <Image src="/img/home.svg" alt="home" height={24} width={24} />
        </div>
      </Link>
      {routes.map(({ name, href }, index) => (
        <Fragment key={name}>
          {index ? (
            <Typography tag="span" className="text-gray-500 font-semibold mx-3">
              &gt;
            </Typography>
          ) : null}
          <Link
            href={href}
            className={`cursor-pointer ${index === routes.length - 1 ? "text-primary truncate" : "text-gray-500"} font-medium`}
          >
            {name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()}
          </Link>
        </Fragment>
      ))}
    </div>
  </div>
);

export default BreadCrumb;
